import React, {Component} from 'react';
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {reverseParseTextView} from './createRender';
import {Rate,Tooltip, Row, Col} from 'antd'
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';


const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        this.setState({visible: val});
    };

    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
        let data = reverseParseTextView(this.props.data);
        this.props.getDate && this.props.getDate(data);
    }
    componentDidUpdate(preProps) {
        if (preProps.data.question_id !== this.props.data.question_id) {
            let data = reverseParseTextView(this.props.data);
            this.props.getDate && this.props.getDate(data);
        }

        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', (d) => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    }


    createHtml = str => ({__html: str ? str : `&nbsp;`});

    render() {
        const {visible} = this.state;
        let originData = this.props.data;
        
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案
        const {num='undefined', children,canShowAnswer} = this.props;
        let data = reverseParseTextView(originData);
        const { answer, is_group, is_order, is_unique, numbers, reference_answer} = data.answer;
        return (
            <div className="box-exercise" ref={'viewer'}>
                {/*<div className="box-exercise" ref={(el) => {this.viewer = el}}>*/}
                 <div className="exercise-content">
                     {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    <div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(data.stem)}/>
                    <div className="footer-equation">
                        <Row type="flex" align="middle">
                            <Col>
                                <p className="equation-answer-item">答案要求：</p>
                            </Col>
                            <Col className="equation-answer-list">
                                {
                                   is_order == 1 ? <span>数字有序</span> : null 
                                }
                                {
                                   is_group == 1 ? <span>允许组合</span> : null 
                                }
                                {
                                   is_unique == 1 ? <span>答案唯一</span> : null 
                                }
                            </Col>
                        </Row>
                        <Row type="flex" align="middle">
                            <Col>
                                <p className="equation-answer-item">可填数字：</p>
                            </Col>
                            <Col className="equation-answer-list">
                                <span>{numbers}</span>
                            </Col>
                        </Row>
                        <Row type="flex" align="middle">
                            <Col>
                                <p className="equation-answer-item">等于值：</p>
                            </Col>
                            <Col className="equation-answer-list">
                                <span>{answer}</span>
                            </Col>
                        </Row>
                        <Row type="flex" align="middle">
                            <Col>
                                <p className="equation-answer-item">参考答案：</p>
                            </Col>
                            <Col className="equation-answer-list">
                                <span>{reference_answer}</span>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="exercise-footer">
                    {
                        visible && 
                        <div className="footer-hide relative" style={{fontSize: '14px'}}>
                            <Row>
                                <Col>正确答案：</Col>
                            </Row>
                        </div>
                        
                    }

                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={() => this.toggleAnswer(!visible)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/equation/viewForView.js